import {
    GET_BOOKINGS_REQUESTS_WAITING,
    BOOKINGS_REQUESTS_WAITING_LOADING,
    GET_BOOKINGS_REQUESTS_WAITING_ERROR,
    BOOKINGS_REQUESTS_CONFIRMED_LOADING,
    GET_BOOKINGS_REQUESTS_CONFIRMED_ERROR,
    GET_BOOKINGS_REQUESTS_CONFIRMED,
    BOOKINGS_REQUESTS_CANCELLED_LOADING, GET_BOOKINGS_REQUESTS_CANCELLED_ERROR, GET_BOOKINGS_REQUESTS_CANCELLED,
    PATCH_CONFIRM_BOOKING_REQUEST,
    PATCH_CANCEL_BOOKING_REQUEST
} from 'app/types'

const initialState = {
    bookingsWaiting: {
        data : [],
        error : null ,
        loading : false
    },
    bookingsConfirmed:{
        data : [],
        error : null ,
        loading : false
    },
    bookingsCancelled:{
        data : [],
        error : null ,
        loading : false
    }
}

export default function bookingsRequestsReducer (state = initialState, action) {

    switch(action.type){
        case BOOKINGS_REQUESTS_WAITING_LOADING :
            return {
                ...state ,
                bookingsWaiting: {
                    ...state.bookingsWaiting,
                    error : null,
                    loading : true
                }

            }
        case GET_BOOKINGS_REQUESTS_WAITING_ERROR :
            return {
                ...state ,
                bookingsWaiting: {
                    ...state.bookingsWaiting,
                    error : action.payload,
                    loading : false
                }

            }
        case GET_BOOKINGS_REQUESTS_WAITING :
            return {
                ...state ,
                bookingsWaiting: {
                    ...state.bookingsWaiting,
                    error : null,
                    loading : false,
                    data : action.payload
                }

            }
        case BOOKINGS_REQUESTS_CONFIRMED_LOADING :
            return {
                ...state ,
                bookingsConfirmed: {
                    ...state.bookingsConfirmed,
                    error : null,
                    loading : true
                }

            }
        case GET_BOOKINGS_REQUESTS_CONFIRMED_ERROR :
            return {
                ...state ,
                bookingsConfirmed: {
                    ...state.bookingsConfirmed,
                    error : action.payload,
                    loading : false
                }

            }
        case GET_BOOKINGS_REQUESTS_CONFIRMED :
            return {
                ...state ,
                bookingsConfirmed: {
                    ...state.bookingsConfirmed,
                    error : null,
                    loading : false,
                    data : action.payload
                }

            }
        case BOOKINGS_REQUESTS_CANCELLED_LOADING :
            return {
                ...state ,
                bookingsCancelled: {
                    ...state.bookingsCancelled,
                    error : null,
                    loading : true
                }

            }
        case GET_BOOKINGS_REQUESTS_CANCELLED_ERROR :
            return {
                ...state ,
                bookingsCancelled: {
                    ...state.bookingsCancelled,
                    error : action.payload,
                    loading : false
                }

            }
        case GET_BOOKINGS_REQUESTS_CANCELLED :
            return {
                ...state ,
                bookingsCancelled: {
                    ...state.bookingsCancelled,
                    error : null,
                    loading : false,
                    data : action.payload
                }
            }
        case PATCH_CONFIRM_BOOKING_REQUEST:
            if(action.payload.bookingSection==="Waiting"){
                return {
                    ...state ,
                    bookingsWaiting: {
                        ...state.bookingsWaiting,
                        error : null ,
                        loading : false ,
                        data : state.bookingsWaiting.data.filter(booking=>booking._id !== action.payload.data._id)
                    },
                    bookingsConfirmed: {
                        ...state.bookingsConfirmed,
                        error : null,
                        loading : false ,
                        data : state.bookingsConfirmed.data.concat(action.payload.data)
                    }
                }
            }else if (action.payload.bookingSection==="Cancelled"){
                return {
                    ...state ,
                    bookingsCancelled: {
                        ...state.bookingsCancelled,
                        error : null ,
                        loading : false ,
                        data : state.bookingsCancelled.data.filter(booking=>booking._id !== action.payload.data._id)
                    },
                    bookingsConfirmed: {
                        ...state.bookingsConfirmed,
                        error : null,
                        loading : false ,
                        data : state.bookingsConfirmed.data.concat(action.payload.data)
                    }
                }
            }
            break;
        case PATCH_CANCEL_BOOKING_REQUEST:
            if(action.payload.bookingSection==="Waiting") {
                return {
                    ...state,
                    bookingsWaiting: {
                        ...state.bookingsWaiting,
                        error: null,
                        loading: false,
                        data: state.bookingsWaiting.data.filter(booking => booking._id !== action.payload.data._id)
                    },
                    bookingsCancelled: {
                        ...state.bookingsCancelled,
                        error: null,
                        loading: false,
                        data: state.bookingsCancelled.data.concat(action.payload.data)
                    }
                }
            }else if (action.payload.bookingSection==="Confirmed") {
                return {
                    ...state,
                    bookingsConfirmed: {
                        ...state.bookingsConfirmed,
                        error: null,
                        loading: false,
                        data: state.bookingsConfirmed.data.filter(booking => booking._id !== action.payload.data._id)
                    },
                    bookingsCancelled: {
                        ...state.bookingsCancelled,
                        error: null,
                        loading: false,
                        data: state.bookingsCancelled.data.concat(action.payload.data)
                    }
                }
            }
            break;
        default: return state
    }

}

